import { useTranslation } from 'react-i18next'

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select'
import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { EConsentMethod } from '@/pages/RunReport/types'
import { businessLocationData } from '@/pages/Search/Const/BusinessLocationData'
import { selectRunReport } from '@/store/api/RunReport/RunReport.selector'
import { setConsent } from '@/store/api/RunReport/RunReport.slice'

export const BusinessLocationField = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const slice = useAppSelector(selectRunReport)

  const isDelegated =
    slice.useCases.consentSwitchValue &&
    slice.consent.method === EConsentMethod.Delegate

  if (!isDelegated) return null

  const selected = slice.consent.businessLocationName

  const handleChange = (name: string) => {
    const match = businessLocationData.find((item) => item.name === name)
    if (!match) return
    dispatch(
      setConsent({
        ...slice.consent,
        businessLocationName: match.name,
        businessLocationValue: match.value,
      }),
    )
  }

  return (
    <div className="space-y-2">
      <label className="sr-only">
        {t('dashboard.runReport.businessLocation.placeholder')}
      </label>
      <Select value={selected || undefined} onValueChange={handleChange}>
        <SelectTrigger className="h-[46px]">
          {selected
            ? t(selected)
            : t('dashboard.runReport.businessLocation.placeholder')}
        </SelectTrigger>
        <SelectContent side="bottom" align="start" avoidCollisions={false}>
          <SelectGroup>
            {businessLocationData.map((item, index) => (
              <SelectItem key={`${item.name}-${index}`} value={item.name}>
                {t(item.name)}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  )
}
